import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { setModalStatus } from 'redux/slices/modal.slice';
import { wellnub } from 'network/wellnub.api';

const mutationFn = async id => {
  const { data } = await wellnub.patch(
    `/v1/client/wellnubService/nutritionistAppointment/reject/${id}`,
  );
  return data;
};

export const useRejectNutritionistAppointmentService = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries('GET_VIRTUAL_AGENDA_APPOINTMENTS');
      queryClient.invalidateQueries('GET_APPOINTMENTS_WITH_NUTRITIONIST');
      enqueueSnackbar('Se rechazó correctamente la cita con tu nutriologo', {
        variant: 'success',
      });
    },
    onError: ({ response }) => {
      if (response?.data?.isPublic) {
        enqueueSnackbar(response?.data?.message, { variant: 'warning' });
      } else {
        enqueueSnackbar('Algo salió mal, intenta de nuevo más tarde', {
          variant: 'error',
        });
      }
    },
    onSettled: () => {
      dispatch(
        setModalStatus({
          name: 'NUTRITIONIST_APPOINTMENT_CONFIRMATION',
          isActive: false,
        }),
      );
    },
  });
};
